{
  "salon-search-result-page": {
    "buttons": {
      "book-appointment": "PRENDRE RENDEZ-VOUS",
      "explore": "EXPLOREZ",
      "show-more": "AFFICHER L'ARTICLE"
    },
    "text": {
      "salon-around": "Salons à proximité"
    }
  }
}
